(ns manage.ad-variant.drawer.db
  {:deprecated true}
  ;; Remove after https://app.launchdarkly.com/projects/creative-optimizations/flags/activation-details-side-panel/targeting?env=production&env=test&selected-env=test is on
  (:require [re-frame.core :as rf]))

(rf/reg-event-fx ::set-current-variant
  (fn [_ [_ data]]
    {:router/update-query #(assoc % :variant (:uuid data))}))

(rf/reg-sub ::drawer-open?
  :<- [:router/current-route]
  (fn [route]
    (some? (get-in route [:query-params :variant]))))

(rf/reg-event-fx ::drawer-close
  (fn [_]
    {:router/update-query #(dissoc % :variant)}))
